<template>
  <v-card elevation="0">
    <v-tabs>
      <v-tab style="justify-content: flex-start">
        <v-icon small left>mdi-palette-outline</v-icon>Button
      </v-tab>
      <v-tab style="justify-content: flex-start">
        <v-icon small left>mdi-palette-outline</v-icon>Fonts
      </v-tab>
      <v-tab-item>
        <SiteThemeButtonSettings></SiteThemeButtonSettings>
      </v-tab-item>
      <v-tab-item>
        <SiteThemeFontSettings></SiteThemeFontSettings>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import projectMixin from "./project-mixin";
import SiteThemeButtonSettings from "./SiteThemeButtonSettings";
import SiteThemeFontSettings from "./SiteThemeFontSettings";

export default {
  mixins: [projectMixin],
  components: { SiteThemeButtonSettings, SiteThemeFontSettings }
};
</script>